// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__Nxg1F","buttons":"styles_buttons__oy6qv","yes":"styles_yes__dO5Mq","no":"styles_no__P0bR2"};